import _objectWithoutProperties from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["spec", "onNewView", "signalListeners", "width", "height"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _pt from "prop-types";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import vegaEmbed from 'vega-embed';
import shallowEqual from './utils/shallowEqual';
import getUniqueFieldNames from './utils/getUniqueFieldNames';
import { NOOP } from './constants';
import addSignalListenersToView from './utils/addSignalListenersToView';
import computeSpecChanges from './utils/computeSpecChanges';
import removeSignalListenersFromView from './utils/removeSignalListenersFromView';
import combineSpecWithDimension from './utils/combineSpecWithDimension';

var VegaEmbed = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(VegaEmbed, _React$PureComponent);

  var _super = _createSuper(VegaEmbed);

  function VegaEmbed() {
    var _this;

    _classCallCheck(this, VegaEmbed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "containerRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "viewPromise", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleError", function (error) {
      var _this$props$onError = _this.props.onError,
          onError = _this$props$onError === void 0 ? NOOP : _this$props$onError;
      onError(error); // eslint-disable-next-line no-console

      console.warn(error);
      return undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "modifyView", function (action) {
      if (_this.viewPromise) {
        _this.viewPromise.then(function (view) {
          if (view) {
            action(view);
          }

          return true;
        }).catch(_this.handleError);
      }
    });

    return _this;
  }

  _createClass(VegaEmbed, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createView();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var fieldSet = getUniqueFieldNames([this.props, prevProps]);
      fieldSet.delete('className');
      fieldSet.delete('signalListeners');
      fieldSet.delete('spec');
      fieldSet.delete('style');
      fieldSet.delete('width');
      fieldSet.delete('height'); // Only create a new view if necessary

      if (Array.from(fieldSet).some(function (f) {
        return _this2.props[f] !== prevProps[f];
      })) {
        this.clearView();
        this.createView();
      } else {
        var specChanges = computeSpecChanges(combineSpecWithDimension(this.props), combineSpecWithDimension(prevProps));
        var newSignalListeners = this.props.signalListeners;
        var oldSignalListeners = prevProps.signalListeners;

        if (specChanges) {
          if (specChanges.isExpensive) {
            this.clearView();
            this.createView();
          } else {
            var areSignalListenersChanged = !shallowEqual(newSignalListeners, oldSignalListeners);
            this.modifyView(function (view) {
              if (specChanges.width !== false) {
                view.width(specChanges.width);
              }

              if (specChanges.height !== false) {
                view.height(specChanges.height);
              }

              if (areSignalListenersChanged) {
                if (oldSignalListeners) {
                  removeSignalListenersFromView(view, oldSignalListeners);
                }

                if (newSignalListeners) {
                  addSignalListenersToView(view, newSignalListeners);
                }
              }

              view.run();
            });
          }
        } else if (!shallowEqual(newSignalListeners, oldSignalListeners)) {
          this.modifyView(function (view) {
            if (oldSignalListeners) {
              removeSignalListenersFromView(view, oldSignalListeners);
            }

            if (newSignalListeners) {
              addSignalListenersToView(view, newSignalListeners);
            }

            view.run();
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearView();
    }
  }, {
    key: "createView",
    value: function createView() {
      var _this$props = this.props,
          spec = _this$props.spec,
          onNewView = _this$props.onNewView,
          _this$props$signalLis = _this$props.signalListeners,
          signalListeners = _this$props$signalLis === void 0 ? {} : _this$props$signalLis,
          width = _this$props.width,
          height = _this$props.height,
          options = _objectWithoutProperties(_this$props, _excluded);

      if (this.containerRef.current) {
        var finalSpec = combineSpecWithDimension(this.props);
        this.viewPromise = vegaEmbed(this.containerRef.current, finalSpec, options).then(function (_ref) {
          var view = _ref.view;

          if (addSignalListenersToView(view, signalListeners)) {
            view.run();
          }

          return view;
        }).catch(this.handleError);

        if (onNewView) {
          this.modifyView(onNewView);
        }
      }
    }
  }, {
    key: "clearView",
    value: function clearView() {
      this.modifyView(function (view) {
        view.finalize();
      });
      this.viewPromise = undefined;
      return this;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          style = _this$props2.style; // Create the container Vega draws inside

      return /*#__PURE__*/React.createElement("div", {
        ref: this.containerRef,
        className: className,
        style: style
      });
    }
  }]);

  return VegaEmbed;
}(React.PureComponent);

export { VegaEmbed as default };

_defineProperty(VegaEmbed, "propTypes", {
  className: _pt.string,
  onError: _pt.func
});